import React from "react";
import styled from "@emotion/styled";

export const StyledDiv = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CenteredBlock: React.FC = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};
